import { useMemo } from "react"
import { Badge, Async, Link } from "../../../../../features/ui"
import { Transaction, TransactionSourceType } from "../../../state/types"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { useTransactionHooks } from "../../../hooks/transactionHooks"

type Props = {
    transaction: Transaction
}

export const TransactionSource = (props: Props) => {
    const { transaction } = props

    const { describeSource } = useTransactionHooks()
    const { getRoutePath } = useRoutesHooks()

    const icon = useMemo(() => {
        const icons = new Map<TransactionSourceType, string>()
            .set(TransactionSourceType.CASH_FUND, 'inbox')
            .set(TransactionSourceType.CHECK, 'card-text')
            .set(TransactionSourceType.CREDIT_CARD, 'credit-card')
            .set(TransactionSourceType.CREDIT_PAYMENT, 'cash-stack')
            .set(TransactionSourceType.SALE, 'tags')
            .set(TransactionSourceType.HOARD, 'layers')
        return icons.get(transaction.sourceType)
    }, [transaction])

    const sourcePath = useMemo(() => {
        const routePaths = new Map<TransactionSourceType, RoutePath>()
            .set(TransactionSourceType.CASH_FUND, RoutePath.CASH_FUNDS)
            .set(TransactionSourceType.CHECK, RoutePath.CHECKS)
            .set(TransactionSourceType.CREDIT_CARD, RoutePath.CREDIT_CARDS)
            .set(TransactionSourceType.CREDIT_PAYMENT, RoutePath.CREDIT_PAYMENTS)
            .set(TransactionSourceType.SALE, RoutePath.SALES)
            .set(TransactionSourceType.HOARD, RoutePath.HOARDS)
        const tablePath = routePaths.get(transaction.sourceType)!
        const viewableSources = [TransactionSourceType.CHECK, TransactionSourceType.SALE, TransactionSourceType.HOARD, TransactionSourceType.CREDIT_PAYMENT]
        const idPath = viewableSources.includes(transaction.sourceType) ? transaction.sourceId : undefined
        return getRoutePath(tablePath, idPath)
    }, [transaction.sourceType, transaction.sourceId])

    return <Async
        loadFn={async () => {
            const sourceLabel = await describeSource(transaction)
            return [
                TransactionSourceType.MANUAL_ADDITION,
                TransactionSourceType.CANCELLATION
            ].includes(transaction.sourceType) ?
                <Badge label={sourceLabel} /> :
                <Link
                    text={sourceLabel}
                    icon={icon}
                    kind="primary"
                    to={sourcePath}
                />
        }}
    />
}
